import { SortDictionaryDefinition } from "./../../helpers/sorter-definition-dictionary";
import { CitelineListTabState } from "./citeline-list-tab-state";
import { CaseRelationModel } from "./../case-relation";
import { ListTabModel } from "./list-tab";
import { GenericTabModel } from "./generic-tab";
import { BasicTabState } from "./basic-tab-state";
import { IDocumentModel } from "./../../interfaces/document-model";
import { prop } from "../../../decorators/property";
import { ITabDefinition } from "../../interfaces/tab-definition";
import { TabViewDictionary } from "./../../helpers/tab-view-dictionary";
import { SortDictionary, SortableCollection } from "../../collections/sortable-collection";
import { Collection } from "backbone-associations";

export class CiteLineListTabModel extends ListTabModel {

    @prop() public State: CitelineListTabState = new CitelineListTabState();
    @prop() public RelationCollection: SortableCollection<CaseRelationModel>;
    @prop() public Sorters: SortDictionaryDefinition[];

    public constructor(properties: ITabDefinition, data: IDocumentModel) {
        super(properties, data);
        if (this.Data && this.Data.get(properties.CollectionName)) {
            this.RelationCollection = new SortableCollection<CaseRelationModel>(this.Sorters, this.Data.get(properties.CollectionName));
        }
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/tabs/citeline-list-tab.ts